module.exports = __webpack_public_path__ + "static/media/document1.61dd6be8.png";